import * as React from 'react'
import { useTranslation } from 'react-i18next'
import Input from 'components/Input'

export const InsuranceFields = () => {
  const { t } = useTranslation()

  return (
    <>
      <Input label={t('ldr.insurance.companyName')} name="companyName" />
      <Input label={t('ldr.insurance.claimNumber')} name="claimNumber" />
    </>
  )
}

export default InsuranceFields
